const detectFileKind = async (blob, contentType) => {
    if (contentType === 'application/pdf') return 'pdf';
    if (contentType?.startsWith('image/')) return 'image';

    // only for octet-stream
    const buf = await blob.slice(0, 4).arrayBuffer();
    const b = new Uint8Array(buf);

    // %PDF
    if (b[0] === 0x25 && b[1] === 0x50 && b[2] === 0x44 && b[3] === 0x46)
        return 'pdf';

    // jpg / png
    if (b[0] === 0xff || b[0] === 0x89) return 'image';

    return 'unknown';
};

const getBlobAndBufferAndContentType = async ({ fileUrl, headers = {} }) => {
    try {
        const isExternal = !String(fileUrl).includes('amazonaws.com');

        const response = await fetch(fileUrl, {
            method: 'GET',
            ...(isExternal ? { headers } : {}),
        });

        if (!response.ok) {
            throw new Error(`Fetch failed with status ${response.status}`);
        }

        const contentType =
            response.headers.get('content-type') || 'application/octet-stream';

        const blob = await response.blob();
        const fileKind = await detectFileKind(blob, contentType);
        const blobUrl = URL.createObjectURL(blob);

        console.log('Fetched file with contentType:', contentType, 'and fileKind:', fileKind);
        return {
            blobUrl,
            buffer: blob,
            contentType,
            fileKind,
        };
    } catch (error) {
        console.error('Error in getBlobAndBufferAndContentType:', error);
        return {
            blobUrl: fileUrl,
            buffer: null,
            contentType: null,
            fileKind: null
        }
      }

};


export { getBlobAndBufferAndContentType };
